import {
    Button,
    Card,
    Col,
    Form,
    Input,
    message,
    Row,
    Select,
    Switch,
} from "antd";
import React from "react";
import { deepOmit } from "../../ProgressLevel/renderEditor/helper";
import { useWorksheetState } from "src/modules/worksheet/components/contexts/WorksheetContext";
import _ from "lodash";
import FigmaStoryEditor from "../../Figma/renderEditor/FigmaStoryEditor";
import isValidCallback from "../isValid";
import { BLOCK_TYPES } from "../../../common";
import { AudioGenerateComponent } from "src/modules/worksheet/components/WorksheetEditor/components/Modals/AudioGenerateComponent";
import KTWrapper from "src/modules/worksheet/components/custom/KTComponent";
import GenerateQuesSummaryFormModal from "src/modules/worksheet/components/custom/GenerateQuesSummaryFormModal";

type Props = {};
const { ALL_IN_ONE } = BLOCK_TYPES;

export function deleteIdsForBlock(block: any) {
    const currentRounds = block?.data?.all_in_one?.rounds || [];
    const newRounds = currentRounds.map((round: any) => {
        return {
            ...round,
            round_id: undefined,
            id: undefined,
        };
    });
    return {
        ...block,
        data: {
            ...block.data,
            all_in_one: { ...block.data.all_in_one, rounds: newRounds },
        },
        id: undefined,
    };
}

function MultiplayerQuestionColumn(props) {
    const { worksheet, block, disableWrite, setBlock, previewData } = props;
    const { publishedBlocksMap = {} }: any = useWorksheetState();

    const {
        id,
        data: {
            other: { stories = [] },
            [ALL_IN_ONE]: {
                is_single_player = false,
                logic: { variables = [] } = {},
            },
        },
        backend: { no_badge = false, badge_count = 0 },
    } = block;

    const figmaStoryEditorProps = {
        ...props,
        disableWrite:
            disableWrite ||
            (!block?.id && worksheet?.type !== "personalized_learning_v4"),
        stories,
        storiesPath: [id || block.data?.storiesId, "data", "other", "stories"],
        setStories: (data: any, storiesId: any) => {
            let tmpBlock = _.cloneDeep(block);
            tmpBlock = _.set(tmpBlock, ["data", "other", "stories"], data);
            if (storiesId)
                tmpBlock = _.set(tmpBlock, ["data", "storiesId"], storiesId);
            setBlock(tmpBlock);
        },
        previewData: block?.id
            ? {
                  ...previewData,
                  variant_id: block?.id,
                  block_id: block?.id,
              }
            : null,
    };

    return (
        <Card>
            <Row gutter={[20, 20]}>
                <Col span={12}>
                    {worksheet?.type === "personalized_learning_v4" &&
                        block?.id && (
                            <Form.Item label="Block Id">
                                <Input.Search
                                    value={block.id}
                                    onChange={() => {}}
                                    enterButton="Copy"
                                    size="small"
                                    onSearch={() => {
                                        message.info(`Copied Id to clipboard!`);
                                        navigator.clipboard.writeText(block.id);
                                    }}
                                />
                            </Form.Item>
                        )}
                </Col>
                <Col span={12}>
                    {worksheet?.type === "personalized_learning_v4" &&
                        block?.id && (
                            <Form.Item label="Published Block Id">
                                {publishedBlocksMap[block.id] ? (
                                    <Input.Search
                                        value={publishedBlocksMap[block.id]}
                                        onChange={() => {}}
                                        enterButton="Copy"
                                        size="small"
                                        onSearch={() => {
                                            message.info(
                                                `Copied Id to clipboard!`,
                                            );
                                            navigator.clipboard.writeText(
                                                block.id,
                                            );
                                        }}
                                    />
                                ) : (
                                    <span>Not published Yet</span>
                                )}
                            </Form.Item>
                        )}
                </Col>
                <Col span={12}>
                    <Form.Item
                        label="No badge required?"
                        rules={[{ required: true }]}
                    >
                        <Switch
                            disabled={disableWrite}
                            checked={no_badge}
                            onChange={(value) => {
                                let tmpBlock = _.cloneDeep(block);
                                tmpBlock = _.set(
                                    tmpBlock,
                                    ["backend", "no_badge"],
                                    value,
                                );
                                setBlock(tmpBlock);
                            }}
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="Slug">
                        <Input
                            value={block?.backend?.slug}
                            disabled={disableWrite}
                            onChange={(e) => {
                                const value = e.target.value;
                                let tmpBlock = _.cloneDeep(block);
                                tmpBlock = _.set(
                                    tmpBlock,
                                    worksheet?.type ===
                                        "personalized_learning_v4"
                                        ? ["backend", "slug"]
                                        : ["data", "slug"],
                                    value,
                                );
                                setBlock(tmpBlock);
                            }}
                        />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item>
                        <Button
                            disabled={disableWrite}
                            type="primary"
                            size="small"
                            onClick={() => {
                                let tmpBlock = deepOmit(block, [
                                    "is_modified",
                                    "changes_list",
                                    "master_block",
                                ]);

                                navigator.clipboard.writeText(
                                    JSON.stringify(tmpBlock),
                                );
                                message.info(`Copied Question to clipboard!`);
                            }}
                        >
                            Copy the Question to Clipboard
                        </Button>
                    </Form.Item>
                    <GenerateQuesSummaryFormModal
                        block_id={block?.id}
                        worksheet={worksheet}
                        level_id={previewData.progression_id}
                        value={_.get(block, ["data", "other", "block_summary"])}
                        setBlock={(value: any) => {
                            let tmpBlock = _.cloneDeep(block);
                            tmpBlock = _.set(
                                tmpBlock,
                                ["data", "other", "block_summary"],
                                value,
                            );
                            setBlock(tmpBlock);
                        }}
                    />
                </Col>
                <Col span={12}>
                    <Form.Item>
                        <Button
                            disabled={disableWrite}
                            type="primary"
                            size="small"
                            onClick={() => {
                                navigator.clipboard
                                    .readText()
                                    .then((text) => {
                                        const parsedData = JSON.parse(text);
                                        const modifiedData =
                                            deleteIdsForBlock(parsedData);
                                        if (
                                            isValidCallback({
                                                block: modifiedData,
                                                worksheet,
                                            }).isValid
                                        ) {
                                            setBlock(modifiedData);
                                        }
                                    })
                                    .catch((err) => {
                                        console.error(
                                            "Failed to read clipboard contents: ",
                                            err,
                                        );
                                    });
                            }}
                        >
                            Paste the Question
                        </Button>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <h3>Background Audio</h3>
                    <AudioGenerateComponent
                        name={"Background Audio"}
                        onSave={(data: any) => {
                            setBlock({
                                ...block,
                                data: {
                                    ...block.data,
                                    other: {
                                        ...block.data.other,
                                        audio: data,
                                    },
                                },
                            });
                        }}
                        audioData={block?.data?.other?.audio}
                    />
                </Col>
                {is_single_player && (
                    <>
                        <Col span={12}>
                            <Row gutter={24}>
                                <Col span={8}>
                                    <KTWrapper feature="badge_count">
                                        <Form.Item
                                            label="Badge Count"
                                            rules={[
                                                { required: is_single_player },
                                            ]}
                                            validateStatus={
                                                !badge_count || badge_count <= 0
                                                    ? "error"
                                                    : ""
                                            }
                                            help={
                                                !badge_count || badge_count <= 0
                                                    ? "Field cannot be empty"
                                                    : ""
                                            }
                                        >
                                            <Input
                                                disabled={disableWrite}
                                                value={badge_count}
                                                onChange={(e) => {
                                                    const value =
                                                        e.target.value;
                                                    let tmpBlock =
                                                        _.cloneDeep(block);
                                                    tmpBlock = _.set(
                                                        tmpBlock,
                                                        worksheet?.type ===
                                                            "personalized_learning_v4"
                                                            ? [
                                                                  "backend",
                                                                  "badge_count",
                                                              ]
                                                            : [
                                                                  "data",
                                                                  ALL_IN_ONE,
                                                                  "badge_count",
                                                              ],
                                                        value,
                                                    );
                                                    setBlock(tmpBlock);
                                                }}
                                                required
                                                type="number"
                                                placeholder={`Badge Count`}
                                            />
                                        </Form.Item>
                                    </KTWrapper>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Total Lives"
                                rules={[{ required: is_single_player }]}
                                validateStatus={
                                    !(
                                        variables?.find(
                                            (v: { name: string }) =>
                                                v.name === "total_lives",
                                        )?.value > 0
                                    )
                                        ? "error"
                                        : ""
                                }
                                help={
                                    !(
                                        variables?.find(
                                            (v: { name: string }) =>
                                                v.name === "total_lives",
                                        )?.value > 0
                                    )
                                        ? "Field cannot be empty"
                                        : ""
                                }
                            >
                                <Input
                                    disabled={disableWrite}
                                    value={
                                        variables?.find(
                                            (v: { name: string }) =>
                                                v.name === "total_lives",
                                        )?.value
                                    }
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        let tmpBlock = _.cloneDeep(block);
                                        let idx = variables?.findIndex(
                                            (v: { name: string }) =>
                                                v.name === "total_lives",
                                        );
                                        if (idx >= 0) {
                                            tmpBlock = _.set(
                                                tmpBlock,
                                                [
                                                    "data",
                                                    ALL_IN_ONE,
                                                    "logic",
                                                    "variables",
                                                    idx,
                                                    "value",
                                                ],
                                                value,
                                            );
                                        } else {
                                            tmpBlock = _.set(
                                                tmpBlock,
                                                [
                                                    "data",
                                                    ALL_IN_ONE,
                                                    "logic",
                                                    "variables",
                                                    variables?.length,
                                                ],
                                                {
                                                    name: "total_lives",
                                                    objectType: "NUMBER",
                                                    value,
                                                },
                                            );
                                        }
                                        setBlock(tmpBlock);
                                    }}
                                    required
                                    type="number"
                                    placeholder={`Total Lives`}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Max possible stars">
                                <Input
                                    disabled={disableWrite}
                                    value={block?.backend?.max_stars || 1}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        let tmpBlock = _.cloneDeep(block);
                                        tmpBlock = _.set(
                                            tmpBlock,
                                            ["backend", "max_stars"],
                                            Number(value),
                                        );
                                        setBlock(tmpBlock);
                                    }}
                                    type="number"
                                    placeholder={`Max possible stars`}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <KTWrapper feature="Set_block">
                                <Form.Item label="Set">
                                    <Select
                                        value={
                                            block?.data?.all_in_one?.logic
                                                ?.sets || []
                                        }
                                        mode="multiple"
                                        onChange={(value) => {
                                            let tmpBlock = _.cloneDeep(block);
                                            _.set(
                                                tmpBlock,
                                                [
                                                    "data",
                                                    "all_in_one",
                                                    "logic",
                                                    "sets",
                                                ],
                                                value,
                                            );
                                            setBlock(tmpBlock);
                                        }}
                                    >
                                        {[
                                            ...Array(
                                                parseInt(
                                                    worksheet?.level_settings
                                                        ?.number_of_sets ?? 0,
                                                ),
                                            ),
                                        ].map((v, i) => {
                                            return (
                                                <Select.Option
                                                    value={i + 1}
                                                    key={i}
                                                >
                                                    {i + 1}
                                                </Select.Option>
                                            );
                                        })}
                                    </Select>
                                </Form.Item>
                            </KTWrapper>
                        </Col>
                    </>
                )}
                <Col span={24}>
                    <Form.Item
                        label={<h2>Stories</h2>}
                        labelCol={{
                            span: 24,
                        }}
                    >
                        <FigmaStoryEditor {...figmaStoryEditorProps} />
                    </Form.Item>
                </Col>
            </Row>
        </Card>
    );
}

export default MultiplayerQuestionColumn;
